import React, { useState } from 'react';

const clients = [
  {
    name: 'AgileBrain',
    logo: 'https://agilebrain.com/wp-content/uploads/2023/02/AB-horiz-white-text-600px.png',
    width: 150,
    invert: false,
  },
  {
    name: 'Sprinklenet',
    logo: 'https://sprinklenet.com/wp-content/uploads/2025/01/Sprinklenet-Logo_White-1024x161.webp',
    width: 170,
    invert: false,
  },
  {
    name: 'Oozle AI',
    logo: 'https://www.oozle.ai/Graphics/OOZLE%20Logos/OOZLEai%20Logo%20-%20840x266.png',
    width: 130,
    invert: true,
  },
  {
    name: 'Huntfor',
    logo: 'https://huntfor.co/images/wordmark.svg',
    width: 130,
    invert: true,
  },
];

const ClientLogo: React.FC<{ c: typeof clients[number] }> = ({ c }) => {
  const [failed, setFailed] = useState(false);
  if (failed) return <span className="client-logo-text">{c.name}</span>;
  return (
    <img
      src={c.logo}
      alt={c.name}
      onError={() => setFailed(true)}
      style={{
        width: c.width,
        height: 'auto',
        filter: c.invert ? 'brightness(0) invert(1)' : undefined,
      }}
    />
  );
};

const Clients: React.FC = () => (
  <section className="clients">
    <div className="container">
      <p className="clients-label">Trusted by teams that build seriously</p>
      <div className="clients-row">
        {clients.map(c => (
          <div className="client-logo" key={c.name}>
            <ClientLogo c={c} />
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Clients;
